import {
    makeStyles
} from "@mui/styles";
import {
    Grid
} from '@mui/material';

const useStyles = makeStyles({
    main: {
        marginBottom: "10px",
        display: "flex",
        backgroundColor: "white",
        borderRadius: "10px",
        boxShadow: "5px 5px 21px 4px #00000014",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px"
    },
    userView: {
        display: "flex",
        alignItems: "center"
    },
    profile: {
        borderRadius: "50px",
        background: "linear-gradient(180deg,#d92cc1,#4D72F8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "30px",
        width: "30px"
    },
    profileSymbol: {
        color: "white"
    },
    centerView: {
        marginLeft: "10px"
    },
    username: {
        margin: "0px",
        fontWeight: "bold",
        fontSize: "14px !important"
    },
    msg: {
        margin: "0px",
        fontSize: "13px"
    },
    time: {
        margin: "0px",
        fontSize: "12px"
    },
    countView: {
        marginTop: "2px",
        background: "linear-gradient(180deg,#d92cc1,#4D72F8)",
        padding: "5px",
        width: "16px",
        height: "16px",
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%"
    },
    count: {
        margin: "0px",
        fontSize: "11px !important",
        color: "white",
        fontWeight: "bold !important"
    }
});

const CovnersationCard = () => {
    const classes = useStyles();

    return (
        <Grid className={classes.main}>
            <Grid className={classes.userView}>
                <Grid className={classes.profile}>
                    <p className={classes.profileSymbol}>MI</p>
                </Grid>
                <Grid className={classes.centerView}>
                    <p className={classes.username}>Mishal Irfan</p>
                    <p className={classes.msg}>Are you available for meeting?</p>
                </Grid>
            </Grid>
            <Grid className={classes.timeView}>
                <p className={classes.time}>2:34pm</p>
                <Grid className={classes.countView}>
                    <p className={classes.count}>2</p>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CovnersationCard;